import React from 'react'
import { DumbField } from '../Field'
import { TextInput, RadioInput, Select, FullName, Checkbox, FullNameDisplay, DateInput } from './Form'
import { noop } from 'utilities'
import { stateOptions } from '../selectOptions'
import SearchIcon from '@tecuity/sos-icons/react/search-heavy'
import RevertIcon from '@tecuity/sos-icons/react/revert'
import { Modal } from 'components/Modal/Modal'
import { HelpTooltip } from './HelpTooltip'
import Portal from 'components/Portal/Portal'
import { SEARCH_UCC_INFO_REQ } from 'requests'
import orderBy from 'lodash/orderBy'
import format from 'date-fns/format'
import { setErrorToast } from '../../../actions'
import { connect } from 'react-redux'

const STATE_OPTIONS = [{ value: '', label: '' }, ...stateOptions]
const UCC_SEARCH_ALLOW_SEARCH_TYPE = process.env.UCC_SEARCH_ALLOW_SEARCH_TYPE
const UCC_SEARCH_REQUEST_TYPE_LABEL_1 = process.env.UCC_SEARCH_REQUEST_TYPE_LABEL_1
const UCC_SEARCH_REQUEST_TYPE_LABEL_2 = process.env.UCC_SEARCH_REQUEST_TYPE_LABEL_2
const UCC_SEARCH_NAME_ORG_LABEL = process.env.UCC_SEARCH_NAME_ORG_LABEL
const UCC_SEARCH_ONLY_REQUIRE_LAST_NAME = process.env.UCC_SEARCH_ONLY_REQUIRE_LAST_NAME
const UCC_SEARCH_ALLOW_START_DATE = process.env.UCC_SEARCH_ALLOW_START_DATE

export class UCCSearch extends React.Component {
  state = {
    modalOpen: false,
    rawRow: [],
    searching: false,
    renderHeadlessModal: false
  }
  setByKey = (key, value) => {
    this.props.onChange({
      ...this.props.value,
      search: {
        ...this.props.value.search,
        [key]: value
      }
    })
  }
  setName = name => {
    this.props.onChange({
      ...this.props.value,
      search: {
        ...this.props.value.search,
        ...Object.entries(name).reduce(
          (obj, ent) => ({
            ...obj,
            [`SEARCH_${ent[0]}`]: ent[1]
          }),
          {}
        )
      }
    })
  }
  search = () => {
    const { value, uccMode, skipResultSelection } = this.props
    this.setState({ searching: true })
    const isOrg = value.search.IS_ORG === "true" || value.search.IS_ORG === true
    SEARCH_UCC_INFO_REQ(
      {
        SEC_PARTY_SEARCH_YN: false,
        SEARCH_IS_ORG: isOrg,
        SEARCH_LAST_NAME: isOrg ? "" : value.search.SEARCH_LAST_NAME,
        SEARCH_FIRST_NAME: isOrg ? "" : value.search.SEARCH_FIRST_NAME,
        SEARCH_MIDDLE_NAME: isOrg ? "" : value.search.SEARCH_MIDDLE_NAME,
        SEARCH_SUFFIX: isOrg ? "" : value.search.SEARCH_SUFFIX,
        SEARCH_ORG_NAME: isOrg ? value.search.SEARCH_ORG_NAME : "",
        SEARCH_CITY: value.search.SEARCH_CITY,
        SEARCH_STATE: value.search.SEARCH_STATE,
        SEARCH_LAPSED: value.search.SEARCH_LAPSED,
        SEARCH_TYPE: value.search.SEARCH_TYPE,
        SEARCH_REQUEST_TYPE: value.search.SEARCH_REQUEST_TYPE,
        SEARCH_UCC: value.search.SEARCH_UCC,
        SEARCH_GOV: value.search.SEARCH_GOV,
        SEARCH_EFS: value.search.SEARCH_EFS,
        SEARCH_CROP_LIEN: value.search.SEARCH_CROP_LIEN,
        SEARCH_AG_LIEN: value.search.SEARCH_AG_LIEN,
        SEARCH_MODE: uccMode,
        SEARCH_UCC_NUM: value.search.SEARCH_UCC_NUM,
        BEGIN_DATE: value.search.BEGIN_DATE
      },
      records => {
        // console.log(records)
        const rows = orderBy(
          Object.values(records.rows).map(row => row),
          ['SORT_INDEX'],
          'desc'
        ).map(row =>
          records.template.map(t => {
            const cell = row[t.id]
            if (Array.isArray(cell)) {
              if (cell.length > 1) {
                return cell.split('\n')
              }
              return cell[0]
            }
            return cell
          })
        )
        // console.log(rows)
        this.setState(
          {
            modalOpen: skipResultSelection ? false : true,
            renderHeadlessModal: skipResultSelection,
            template: records.template,
            rows,
            rawRows: records.rows,
            searching: false
          },
          () => {
            if (skipResultSelection) {
              this.resultsModal.triggerConfirm()
              this.setState({
                renderHeadlessModal: false
              })
            }
          }
        )
      },
      err => {
        console.error(err)
        this.props.setErrorToast(err.internalerror)
        this.setState({
          searching: false
        })
      }
    )
  }
  onConfirm = ({ cache, indexes }) => {
    const rawRows = orderBy(
      Object.values(this.state.rawRows).map(x => x),
      ['SORT_INDEX'],
      'desc'
    )
    const ids = indexes.map(i => rawRows[i].ID)
    const IS_PARTIAL = rawRows.length > indexes.length
    this.props.onChange({ ...this.props.value, IS_PARTIAL, cache, ids })
  }
  deSelect = () => {
    this.setState({ modalOpen: false, template: null, rawRow: null })
    this.props.onChange({ ...this.props.value, cache: null, ids: null })
  }
  getCanSearch = () => {
    const { value, disabled, uccMode } = this.props
    const atLeastOneBoxChecked =
      !value.search.SEARCH_UCC &&
      !value.search.SEARCH_GOV &&
      !value.search.SEARCH_EFS &&
      !value.search.SEARCH_CROP_LIEN &&
      !value.search.SEARCH_AG_LIEN
    if (this.state.searching || disabled) {
      return false
    }
    if (uccMode.toString() === '4') {
      if (atLeastOneBoxChecked) {
        return false
      }
    }
    if (UCC_SEARCH_ALLOW_SEARCH_TYPE) {
      if (value.search.SEARCH_TYPE === 'DEBTOR' || value.search.SEARCH_TYPE === 'SECURED_PARTY') {
        if (value.search.IS_ORG === true || value.search.IS_ORG === 'true') {
          if (!value.search.SEARCH_ORG_NAME) {
            return false
          }
        } else if ((UCC_SEARCH_ONLY_REQUIRE_LAST_NAME ? false : !value.search.SEARCH_FIRST_NAME) || !value.search.SEARCH_LAST_NAME) {
          return false
        }
      } else if (value.search.SEARCH_TYPE === 'UCC_NUM') {
        if (!value.search.SEARCH_UCC_NUM) {
          return false
        }
      }
    } else if (value.search.IS_ORG === true || value.search.IS_ORG === 'true') {
      if (!value.search.SEARCH_ORG_NAME) {
        return false
      }
    } else if (!value.search.SEARCH_FIRST_NAME || !value.search.SEARCH_LAST_NAME) {
      return false
    }

    return true
  }
  render() {
    const { value, disabled, uccMode, fieldId } = this.props
    const fieldsDisabled = disabled || value.cache ? true : false

    return (
      <React.Fragment>
        <div className="sub-section organization-search ucc-box">
          <h3>
            <SearchIcon /> Search for UCC Documents
          </h3>
          {value.cache && (
            <div className="flex-row button-row">
              <button
                disabled={disabled}
                type="button"
                className="btn btn-raised btn-primary search-button"
                onClick={this.deSelect}
                ref={focusTarget => {
                  this.focusTarget = focusTarget
                }}
              >
                <RevertIcon /> &nbsp; Clear Results & Re-Search
              </button>
            </div>
          )}
          <DumbField label={UCC_SEARCH_ALLOW_SEARCH_TYPE ? 'Request Type' : 'Search Type'}>
            <RadioInput
              value={value.search.SEARCH_REQUEST_TYPE}
              onChange={v => this.setByKey('SEARCH_REQUEST_TYPE', v)}
              onBlur={noop}
              disabled={fieldsDisabled}
              options={[
                { value: 'LIST_ONLY', label: UCC_SEARCH_REQUEST_TYPE_LABEL_1 || 'Search request only' },
                { value: 'LIST_AND_COPIES', label: UCC_SEARCH_REQUEST_TYPE_LABEL_2 || 'Both search and copy request' }
              ]}
            />
          </DumbField>
          {UCC_SEARCH_ALLOW_SEARCH_TYPE ? (
            <DumbField label="Search Type">
              <RadioInput
                leftAlign
                value={value.search.SEARCH_TYPE}
                onChange={v => this.setByKey('SEARCH_TYPE', v)}
                onBlur={noop}
                disabled={fieldsDisabled}
                options={[
                  { value: 'DEBTOR', label: 'Debtor Search' },
                  { value: 'SECURED_PARTY', label: 'Secured Party Search' },
                  { value: 'UCC_NUM', label: 'File Number Search' }
                ]}
              />
            </DumbField>
          ) : null}
          {(UCC_SEARCH_ALLOW_SEARCH_TYPE ? (
            value.search.SEARCH_TYPE === 'DEBTOR' || value.search.SEARCH_TYPE === 'SECURED_PARTY'
          ) : (
            true
          )) ? (
            <React.Fragment>
              <DumbField label={UCC_SEARCH_NAME_ORG_LABEL || "Search for an Individual or Organization"}>
                <RadioInput
                  leftAlign
                  value={value.search.IS_ORG}
                  onChange={v => this.setByKey('IS_ORG', v)}
                  onBlur={noop}
                  disabled={fieldsDisabled}
                  options={[
                    { value: false, label: 'Individual' },
                    { value: true, label: 'Organization' }
                  ]}
                />
              </DumbField>
              {value.search.IS_ORG === true || value.search.IS_ORG === 'true' ? (
                <div className="flex-row">
                  <div className="no-field-padding col-sm-8 col-md-6 col-lg-4">
                    <DumbField label="Organization name" className="org-name" required>
                      <TextInput
                        value={value.search.SEARCH_ORG_NAME}
                        onChange={v => this.setByKey('SEARCH_ORG_NAME', v)}
                        onBlur={noop}
                        disabled={fieldsDisabled}
                        width="100%"
                      />
                    </DumbField>
                  </div>
                </div>
              ) : (
                <div className="no-field-padding">
                  <FullName
                    value={{
                      FIRST_NAME: value.search.SEARCH_FIRST_NAME,
                      LAST_NAME: value.search.SEARCH_LAST_NAME,
                      MIDDLE_NAME: value.search.SEARCH_MIDDLE_NAME,
                      SUFFIX: value.search.SEARCH_SUFFIX
                    }}
                    onlyRequireLastName={UCC_SEARCH_ONLY_REQUIRE_LAST_NAME}
                    required
                    suffix
                    onChange={this.setName}
                    onBlur={noop}
                    disabled={fieldsDisabled}
                  />
                </div>
              )}
              <div className="no-field-padding flex-row">
                <div className="col-sm-5 col-md-4 col-lg-3">
                  <DumbField label="City">
                    <TextInput
                      value={value.search.SEARCH_CITY}
                      onChange={v => this.setByKey('SEARCH_CITY', v)}
                      onBlur={noop}
                      disabled={fieldsDisabled}
                    />
                  </DumbField>
                </div>
                <DumbField label="State">
                  <Select
                    value={value.search.SEARCH_STATE}
                    onChange={v => this.setByKey('SEARCH_STATE', v)}
                    options={STATE_OPTIONS}
                    onBlur={noop}
                    disabled={fieldsDisabled}
                  />
                </DumbField>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {UCC_SEARCH_ALLOW_SEARCH_TYPE ? (
                <div className="flex-row">
                  <div className="no-field-padding col-sm-8 col-md-6 col-lg-4">
                    <DumbField label="File Number" className="ucc-num" required>
                      <TextInput
                        value={value.search.SEARCH_UCC_NUM}
                        onChange={v => this.setByKey('SEARCH_UCC_NUM', v)}
                        onBlur={noop}
                        disabled={fieldsDisabled}
                        width="100%"
                      />
                    </DumbField>
                  </div>
                </div>
              ) : null}
            </React.Fragment>
          )}
          {
            UCC_SEARCH_ALLOW_START_DATE ? (
              <div className="flex-row">
                <div className="no-field-padding col-sm-8 col-md-6 col-lg-4">
                  <DumbField label="Start Date" description="Leave empty for all results">
                    <DateInput
                      value={value.search.BEGIN_DATE}
                      onChange={v => this.setByKey('BEGIN_DATE', v)}
                      onBlur={noop}
                      disabled={fieldsDisabled}
                    />
                  </DumbField>
                </div>
              </div>
            )
            : null
          }
          <div className="flex-row checkbox-padding top-box">
            <Checkbox
              fieldId={`${fieldId}-unlapsed`}
              label="Include lapsed filings on search response."
              value={value.search.SEARCH_LAPSED}
              onChange={v => this.setByKey('SEARCH_LAPSED', v)}
              onBlur={noop}
              disabled={fieldsDisabled}
            />
          </div>
          {uccMode.toString() === '4' && (
            <React.Fragment>
              <label className="sub-label">Select at least one of the following:</label>
              <div className="flex-row checkbox-padding">
                <Checkbox
                  fieldId={`${fieldId}-ucc`}
                  label="Include UCC Financing statements (other than farm products)"
                  value={value.search.SEARCH_UCC}
                  onChange={v => this.setByKey('SEARCH_UCC', v)}
                  onBlur={noop}
                  disabled={fieldsDisabled}
                />
              </div>
              <div className="flex-row checkbox-padding">
                <Checkbox
                  fieldId={`${fieldId}-tax`}
                  label="Include Government Liens (IRS, indigent, employment, state tax, etc.)"
                  value={value.search.SEARCH_GOV}
                  onChange={v => this.setByKey('SEARCH_GOV', v)}
                  onBlur={noop}
                  disabled={fieldsDisabled}
                />
              </div>
              <div className="flex-row checkbox-padding">
                <Checkbox
                  fieldId={`${fieldId}-efs`}
                  label="Include Effective financing statements (EFS) pertaining to farm products"
                  value={value.search.SEARCH_EFS}
                  onChange={v => this.setByKey('SEARCH_EFS', v)}
                  onBlur={noop}
                  disabled={fieldsDisabled}
                />
              </div>
              <div className="flex-row checkbox-padding">
                <Checkbox
                  fieldId={`${fieldId}-crop-lien`}
                  label="Include liens in crops, for seed or farm labor"
                  value={value.search.SEARCH_CROP_LIEN}
                  onChange={v => this.setByKey('SEARCH_CROP_LIEN', v)}
                  onBlur={noop}
                  disabled={fieldsDisabled}
                />
              </div>
              <div className="flex-row checkbox-padding">
                <Checkbox
                  fieldId={`${fieldId}-ag-lien`}
                  label="Include liens on agricultural products, after sale/delivery to purchasers"
                  value={value.search.SEARCH_AG_LIEN}
                  onChange={v => this.setByKey('SEARCH_AG_LIEN', v)}
                  onBlur={noop}
                  disabled={fieldsDisabled}
                />
              </div>
            </React.Fragment>
          )}
          <div className="flex-row button-row">
            {!fieldsDisabled && (
              <button
                className="btn btn-primary btn-raised search-button"
                onClick={this.search}
                disabled={!this.getCanSearch()}
              >
                <SearchIcon /> &nbsp; {`${this.state.searching ? 'Searching' : 'Search'}`} &nbsp;
              </button>
            )}
          </div>
          {(this.state.modalOpen || this.state.renderHeadlessModal) && (
            <ResultsModal
              template={this.state.template}
              rows={this.state.rows}
              onRequestClose={() => {
                this.setState({ modalOpen: false })
              }}
              onConfirm={this.onConfirm}
              ref={r => (this.resultsModal = r)}
              headless={this.state.renderHeadlessModal}
            />
          )}
          {value.cache && (
            <div className="ucc-result">
              {/* <UCCSearchDisplay value={value.search} uccMode={uccMode} /> */}
              <table className="styled-table cache-table">
                <thead>
                  <tr>
                    {value.cache.template.map(({ label }, i) => (
                      <th key={i}>{label}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {value.cache.rows.map((row, i) => (
                    <tr key={i}>
                      {row.map((cell, i) => (
                        <td key={i}>{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </React.Fragment>
    )
  }
}

export default connect(
  null,
  {
    setErrorToast
  }
)(UCCSearch)

class ResultsModal extends React.Component {
  state = {
    checked: this.props.rows.reduce((obj, _, i) => ({ ...obj, [i]: true }), {}),
    checkedCount: this.props.rows.length,
    error: null
  }
  submitValid = () => {
    // If we get results from the search, users MUST select one or more.
    if (this.props.rows.length > 0 && this.state.checkedCount > 0) {
      return true
      // If the search returns no results, it should be considered valid.
    } else if (this.props.rows.length == 0 && this.state.checkedCount == 0) {
      return true
    } else return false
  }
  setChecked = (val, i) => {
    let countChange = 0
    if (!this.state.checked[i] && val) {
      countChange = 1
    } else if (this.state.checked[i] && !val) {
      countChange = -1
    }
    this.setState(state => ({
      checked: {
        ...state.checked,
        [i]: val
      },
      checkedCount: state.checkedCount + countChange,
      error: null
    }))
  }
  uncheckAll = () => {
    this.setState({
      checked: this.props.rows.reduce((obj, _, i) => ({ ...obj, [i]: false }), {}),
      checkedCount: 0,
      error: null
    })
  }
  checkAll = () => {
    this.setState({
      checked: this.props.rows.reduce((obj, _, i) => ({ ...obj, [i]: true }), {}),
      checkedCount: this.props.rows.length,
      error: null
    })
  }
  triggerConfirm = () => this.onConfirm()
  onConfirm = callback => {
    if (!this.submitValid()) {
      this.setState({ error: 'You must select at least one record to continue.' })
      return
    } else {
      this.setState({ error: null })
    }
    this.props.onConfirm({
      cache: {
        template: this.props.template,
        rows: this.props.rows.filter((row, i) => this.state.checked[i])
      },
      indexes: Object.keys(this.state.checked).reduce((arr, i) => {
        if (this.state.checked[i]) {
          return [...arr, i]
        } else {
          return arr
        }
      }, [])
    })
    if(callback){
      callback()
    }
  }
  render() {
    const { onRequestClose, rows, template, headless } = this.props
    return (
      <Portal isOpened={headless ? false : true}>
        <Modal modalSize="large" title="UCC Documents" closeModal={onRequestClose} closeButton>
          {({ closeModal }) => (
            <React.Fragment>
              <div className="scrollable ucc-scrollable">
                <div className="ucc-search-modal">
                  <div className="button-wrapper">
                    <button className="btn btn-secondary" onClick={this.uncheckAll}>
                      Uncheck all
                    </button>
                    <button className="btn btn-secondary" onClick={this.checkAll}>
                      Check all
                    </button>
                  </div>
                  <table className="form-table">
                    <thead>
                      <tr>
                        <th />
                        {template.map(({ label }, i) => (
                          <th key={i}>{label}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, i) => (
                        <tr
                          className={`clickable wizard ${
                            this.state.checked[i] ? 'checked' : 'unchecked'
                          }`}
                          onClick={() => this.setChecked(!this.state.checked[i], i)}
                          key={i}
                        >
                          <td>
                            <Checkbox
                              value={this.state.checked[i]}
                              onChange={val => this.setChecked(val, i)}
                            />
                          </td>
                          {row.map((cell, i) => (
                            <td key={i}>{cell}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="ucc-toolbar">
                <button
                  aria-invalid={this.state.error ? true : ''}
                  className="btn btn-secondary"
                  id="ucc-doc-submit"
                  onClick={() => {
                    this.onConfirm(closeModal, this.setError)
                  }}
                >
                  Confirm
                </button>
                <HelpTooltip ariaDescribedBy="ucc-doc-submit" message={this.state.error} />
              </div>
            </React.Fragment>
          )}
        </Modal>
      </Portal>
    )
  }
}

export const UCCSearchDisplay = ({ uccMode, value, disabled }) => {
  const individualOrg = {
    label: 'Individual or Organization:',
    value: value.IS_ORG ? 'Organization' : 'Individual'
  }
  const cells = [
    {
      label: UCC_SEARCH_ALLOW_SEARCH_TYPE ? 'Request Type:' : 'Search Type:',
      value:
        value.SEARCH_REQUEST_TYPE === 'LIST_ONLY'
          ? 'Search request only'
          : 'Both search and copy request'
    },
    UCC_SEARCH_ALLOW_SEARCH_TYPE
      ? {
          label: 'Search Type:',
          value:
            value.SEARCH_TYPE === 'DEBTOR'
              ? 'Debtor Search'
              : value.SEARCH_TYPE === 'SECURED_PARTY'
              ? 'Secured Party Search'
              : value.SEARCH_TYPE === 'UCC_NUM'
              ? 'File Number Search'
              : value.SEARCH_TYPE
        }
      : null,
    ...((UCC_SEARCH_ALLOW_SEARCH_TYPE
    ? value.SEARCH_TYPE === 'DEBTOR' || value.SEARCH_TYPE === 'SECURED_PARTY'
    : true)
      ? value.IS_ORG === true || value.IS_ORG === 'true'
        ? [individualOrg, { label: 'Organization name:', value: value.SEARCH_ORG_NAME }]
        : [
            individualOrg,
            {
              label: 'Individual Name:',
              value: (
                <FullNameDisplay
                  value={{
                    FIRST_NAME: value.SEARCH_FIRST_NAME,
                    MIDDLE_NAME: value.SEARCH_MIDDLE_NAME,
                    LAST_NAME: value.SEARCH_LAST_NAME,
                    SUFFIX: value.SEARCH_SUFFIX
                  }}
                />
              )
            }
          ]
      : [
          {
            label: 'File Number:',
            value: value.SEARCH_UCC_NUM
          }
        ]),
    UCC_SEARCH_ALLOW_SEARCH_TYPE && value.SEARCH_TYPE === 'UCC_NUM'
      ? null
      : {
          label: 'City:',
          value: value.SEARCH_CITY
        },
    UCC_SEARCH_ALLOW_SEARCH_TYPE && value.SEARCH_TYPE === 'UCC_NUM'
      ? null
      : {
          label: 'State:',
          value: value.SEARCH_STATE
        },
    UCC_SEARCH_ALLOW_START_DATE ?
      {
        label: "Start Date:",
        value: value.BEGIN_DATE ? format(new Date(value.BEGIN_DATE), 'MM/dd/yyyy') : value.BEGIN_DATE
      }
    : null,
    {
      label: 'Include lapsed filings on search response:',
      value: value.SEARCH_LAPSED ? 'Yes' : 'No'
    },
    ...(uccMode.toString() === '4'
      ? [
          {
            label: 'Include UCC Financing statements:',
            value: value.SEARCH_UCC ? 'Yes' : 'No'
          },
          {
            label: 'Include Government Liens:',
            value: value.SEARCH_GOV ? 'Yes' : 'No'
          },
          {
            label: 'Include Effective Financing Statements:',
            value: value.SEARCH_EFS ? 'Yes' : 'No'
          },
          {
            label: 'Include liens in crops:',
            value: value.SEARCH_CROP_LIEN ? 'Yes' : 'No'
          },
          {
            label: 'Include liens on agricultural products:',
            value: value.SEARCH_AG_LIEN ? 'Yes' : 'No'
          }
        ]
      : [])
  ].filter(x => x !== null)

  return (
    <div className="ucc-search-display">
      {cells.map((cell, i) => (
        <div className="flex-row ucc-summary-row" key={i}>
          <label className="ucc-label">{cell.label}</label>
          <span className="ucc-value">{cell.value}</span>
        </div>
      ))}
      {/* <table className='styled-table cache-table'>
        <thead>
          <tr>
            <th>Label</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {cells.map((cell, i) => (
            <tr key={i}>
              <td>
                <label className="ucc-label">{cell.label}</label>
              </td>
              <td>
                <span className="ucc-value">{cell.value}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table> */}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/UCCSearch.js